var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "elements"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 6711",
    d: "M4.16602 16.9948C7.67433 13.0353 11.617 7.78437 17.4993 11.7227",
    stroke: "#3D3D3D",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2109",
    d: "M11.666 2.00193C11.2743 2 10.0249 2 9.58268 2C5.85073 2 3.98475 2 2.82538 3.15937C1.66602 4.31874 1.66602 6.18471 1.66602 9.91667C1.66602 13.6486 1.66602 15.5146 2.82538 16.674C3.98475 17.8333 5.85073 17.8333 9.58268 17.8333C13.3146 17.8333 15.1806 17.8333 16.34 16.674C17.4554 15.5586 17.4977 13.7892 17.4993 10.3333",
    stroke: "#3D3D3D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.166 5.74479C14.5756 6.16621 15.6658 7.82813 16.2493 7.82812M18.3327 5.74479C17.9231 6.16621 16.8329 7.82813 16.2493 7.82812M16.2493 7.82812V1.16146",
    stroke: "#3D3D3D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.4bc69a7015f1bd7b8f615bea051557cd.svg";
export { ForwardRef as ReactComponent };